import React from 'react';

interface AideProps {
  message: string;
}
export const Aide: React.FC<AideProps> = ({ message }) => {

  const handleClick = (): void => {
    alert(message);
  }

  return <div className="aide" onClick={handleClick} title={message}>?</div>;
}